import { type Maybe } from 'graphql/jsutils/Maybe';
import { type ReactNode } from 'react';
import { EmptyInfoCardTemplate } from '@components/_templates/InfoCardTemplate/components/EmptyInfoCardTemplate';
import { type Component } from '@gql/graphql';
import { type ComponentCreateRequestMapped } from '@pages/notification-components/models/ComponentCreateRequestMapped';
import { ComponentInfoCard } from './ComponentInfoCard/ComponentInfoCard';
import { RequestInfoCard } from './RequestInfoCard/RequestInfoCard';

interface InfoCardProps {
    component: Maybe<Component>;
    request: Maybe<ComponentCreateRequestMapped>;
}

export function InfoCard({ component, request }: InfoCardProps): ReactNode {
    if (component) {
        return <ComponentInfoCard component={component} />;
    }

    if (request) {
        return <RequestInfoCard request={request} />;
    }

    return <EmptyInfoCardTemplate />;
}
